module.exports = "<div (click)=\"removeOverlay($event)\" [ngClass]=\"{'overlay': overlay}\" #overlayContainer>\n  <ng-content></ng-content>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/overlay/overlay.component.html
// module id = ./src/app/shared-components/overlay/overlay.component.html
// module chunks = main